import Axios from 'axios';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react'
import NotData from '../../components/NotData';
import { useNavigate } from 'react-router-dom';

const Chart_2 = () => {

  const navigate = useNavigate();

  // 시간 불러오는 부분
  let toDate = new dayjs().format('YYYY-MM-DD');
  let toTime = new dayjs().format('YYYY-MM-DD HH:mm:ss')

  const minusDate = (number)=>{
    const now = new dayjs().subtract(number, 'days');
    return now.format('YYYY-MM-DD');
  }

  const plusDate = (number)=>{
    const now = new dayjs().add(number, 'days');
    return now.format('YYYY-MM-DD');
  }

  const toDay = {
    date: toDate,
    time: toTime,
    minusDate,
    plusDate
  }

  // 숫자 천자리 콤마
  function NumberConvert(num) {
    let num_parts = num.toString().split(".");
    num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return num_parts.join(".");
  }
    
  const [books_tb, setBooks_tb] = useState([]);
  const [books_ds, setBooks_ds] = useState([]);
  const [books_jy, setBooks_jy] = useState([]);
  const [books_cd, setBooks_cd] = useState([]);

  const columns_tb = [ '시간대', '탄방 건수', '탄방 수량' ];
  const columns_ds = [ '시간대', '둔산 건수', '둔산 수량' ];
  const columns_jy = [ '시간대', '자양 건수', '자양 수량' ];
  const columns_cd = [ '시간대', '충대 건수', '충대 수량' ];
  
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  // 날짜 및 바로 실행될 부분
  useEffect(()=>{
    document.title = '시간대 조회';

    setStartDate(toDay.minusDate(30))
    setEndDate(toDay.date)
  }, []);

  // 조회 버튼 클릭시
  const btnSearchClick = async (e)=>{
    e.preventDefault();
    
    loadeData();
  }

  // 기간내 시간대별 조회 함수
  const loadeData = async ()=>{

    // 탄방점
    await Axios.get('/api/salechart/chart_date1', {
      params: { startDate: startDate, endDate: endDate }
    })
    .then((res)=>{

      if(res.data.length)
      {
        setBooks_tb(res.data)
      } else {
        setBooks_tb([]);
      }

    });

    // 둔산점
    await Axios.get('/api/salechart/chart_date2', {
      params: { startDate: startDate, endDate: endDate }
    })
    .then((res)=>{

      if(res.data.length)
      {
        setBooks_ds(res.data)
      } else {
        setBooks_ds([]);
      }

    });

    // 자양점
    await Axios.get('/api/salechart/chart_date3', {
      params: { startDate: startDate, endDate: endDate }
    })
    .then((res)=>{

      if(res.data.length)
      {
        setBooks_jy(res.data)
      } else {
        setBooks_jy([]);
      }

    });

    // 충대점
    await Axios.get('/api/salechart/chart_date4', {
      params: { startDate: startDate, endDate: endDate }
    })
    .then((res)=>{

      if(res.data.length)
      {
        setBooks_cd(res.data)
      } else {
        setBooks_cd([]);
      }

    });
  }

  // 셀렉트 테스트
  const [selectedRowTB, setSelectedRowTB] = useState(-1);
  const [selectedRowDS, setSelectedRowDS] = useState(-1);
  const [selectedRowJY, setSelectedRowJY] = useState(-1);
  const [selectedRowCD, setSelectedRowCD] = useState(-1);

  return (
    
    <div className='p-3 flex flex-col gap-3 whitespace-nowrap'>
      <div className='flex justify-between items-center'>
        <ul className='flex gap-3'>
          <li className={`hover:underline cursor-pointer py-2 px-3 overflow-x-auto}`} onClick={(e)=>navigate('/salechart/chart_1')}>기간별 조회</li>
          <li className={`hover:underline cursor-pointer py-2 px-3 overflow-x-auto border-[1px] border-yellow-500 rounded-md`} onClick={(e)=>navigate('/salechart/chart_2')}>시간대 조회</li>
        </ul>
      </div>
      
      <div className='grid grid-cols-1 md:flex md:justify-between text-sm md:h-[calc(100vh-8.9rem)] gap-2'>
      
        {/* 메인 */}
        <div className='relative w-full md:w-3/4 grid md:grid-cols-2  gap-5 md:gap-2'>

          <div className='overflow-y-auto md:h-full h-[30vh] border-[1px] border-gray-500 rounded-sm'>
            <table id='tb_table' className='w-full h-10'>
              <thead className='bg-[#1E1E1E]/90 whitespace-nowrap text-center border-b-[1px] border-gray-500 sticky top-0 z-10'>
                <tr className=''>
                  {columns_tb.map((column) => (
                    <th className='p-3' key={column}>{column}</th>
                  ))}
                </tr>
              </thead>
              <tbody className='text-center'>
                {
                  books_tb.length
                  ?
                  books_tb.map((book, idx) => (
                    <tr className=
                    {`
                      duration-150 decoration-yellow-600 whitespace-nowrap active:scale-[0.98] active:opacity-80
                      ${selectedRowTB === idx ? 'bg-[#1E1E1E] font-bold underline decoration-[3px]' : 'even:bg-[#3E3E3E]'}
                    `}
                    key={idx} onClick={(e)=>{
                      // 셀렉트 테스트
                      setSelectedRowTB(idx);
                    }}>
                      <td className='p-2.5'>{book.no} 시</td>
                      <td className='p-2.5 border-x-[1px] border-gray-500'>{book.count ? `${NumberConvert(book.count)} 건` : '-'}</td>
                      <td className='p-2.5'>{book.total ? `${NumberConvert(book.total)} 개` : '-'}</td>
                    </tr>
                  ))
                  :
                  <tr className='relative'>
                    <td className='absolute w-full md:top-[10vh] top-[3vh] left-auto'>
                      <NotData/>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>

          <div className='overflow-y-auto md:h-full h-[30vh] border-[1px] border-gray-500 rounded-sm'>
            <table id='ds_table' className='w-full'>
              <thead className='bg-[#1E1E1E]/90 whitespace-nowrap text-center border-b-[1px] border-gray-500 sticky top-0 z-10'>
                <tr>
                  {columns_ds.map((column) => (
                    <th className='p-3' key={column}>{column}</th>
                  ))}
                </tr>
              </thead>
              <tbody className='text-center'>
                {
                  books_ds.length ?
                  books_ds.map((book, idx) => (
                    <tr className=
                    {`
                      duration-150 decoration-yellow-600 whitespace-nowrap active:scale-[0.98] active:opacity-80
                      ${selectedRowDS === idx ? 'bg-[#1E1E1E] font-bold underline decoration-[3px]' : 'even:bg-[#3E3E3E]'}
                    `}
                    key={idx} onClick={(e)=>{
                      // 셀렉트 테스트
                      setSelectedRowDS(idx);
                    }}>
                      <td className='p-2.5'>{book.no} 시</td>
                      <td className='p-2.5 border-x-[1px] border-gray-500'>{book.count ? `${NumberConvert(book.count)} 건` : '-'}</td>
                      <td className='p-2.5'>{book.total ? `${NumberConvert(book.total)} 개` : '-'}</td>
                    </tr>
                  ))
                  :
                  <tr className='relative'>
                    <td className='absolute w-full md:top-[10vh] top-[3vh] left-auto'>
                      <NotData/>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>

          <div className='overflow-y-auto md:h-full h-[30vh] border-[1px] border-gray-500 rounded-sm'>
            <table id='jy_table' className='w-full'>
              <thead className='bg-[#1E1E1E]/90 whitespace-nowrap text-center border-b-[1px] border-gray-500 sticky top-0 z-10'>
                <tr className=''>
                  {columns_jy.map((column) => (
                    <th className='p-3' key={column}>{column}</th>
                  ))}
                </tr>
              </thead>
              <tbody className='text-center'>
                {
                  books_jy.length ?
                  books_jy.map((book, idx) => (
                    <tr className=
                    {`
                      duration-150 decoration-yellow-600 whitespace-nowrap active:scale-[0.98] active:opacity-80
                      ${selectedRowJY === idx ? 'bg-[#1E1E1E] font-bold underline decoration-[3px]' : 'even:bg-[#3E3E3E]'}
                    `}
                    key={idx} onClick={(e)=>{
                      // 셀렉트 테스트
                      setSelectedRowJY(idx);
                    }}>
                      <td className='p-2.5'>{book.no} 시</td>
                      <td className='p-2.5 border-x-[1px] border-gray-500'>{book.count ? `${NumberConvert(book.count)} 건` : '-'}</td>
                      <td className='p-2.5'>{book.total ? `${NumberConvert(book.total)} 개` : '-'}</td>
                    </tr>
                  ))
                  :
                  <tr className='relative'>
                    <td className='absolute w-full md:top-[10vh] top-[3vh] left-auto'>
                      <NotData/>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>

          <div className='overflow-y-auto md:h-full h-[30vh] border-[1px] border-gray-500 rounded-sm'>
            <table id='cd_table' className='w-full'>
              <thead className='bg-[#1E1E1E]/90 whitespace-nowrap text-center border-b-[1px] border-gray-500 sticky top-0 z-10'>
                <tr className=''>
                  {columns_cd.map((column) => (
                    <th className='p-3' key={column}>{column}</th>
                  ))}
                </tr>
              </thead>
              <tbody className='text-center'>
                {
                  books_cd.length ?
                  books_cd.map((book, idx) => (
                    <tr className=
                    {`
                      duration-150 decoration-yellow-600 whitespace-nowrap active:scale-[0.98] active:opacity-80
                      ${selectedRowCD === idx ? 'bg-[#1E1E1E] font-bold underline decoration-[3px]' : 'even:bg-[#3E3E3E]'}
                    `}
                    key={idx} onClick={(e)=>{
                      // 셀렉트 테스트
                      setSelectedRowCD(idx);
                    }}>
                      <td className='p-2.5'>{book.no} 시</td>
                      <td className='p-2.5 border-x-[1px] border-gray-500'>{book.count ? `${NumberConvert(book.count)} 건` : '-'}</td>
                      <td className='p-2.5'>{book.total ? `${NumberConvert(book.total)} 개` : '-'}</td>
                    </tr>
                  ))
                  :
                  <tr className='relative'>
                    <td className='absolute w-full md:top-[10vh] top-[3vh] left-auto'>
                      <NotData/>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>

        </div>

        {/* 사이드 */}
        <div className='w-full md:w-1/4 bg-[#424242] border-[1px] border-gray-500'>
          <div className='bg-[#0067BD] py-2 text-center'>
            <p className='text-left pl-3'>
              ※ 시간대별 처리된 데이터 조회
            </p>
          </div>

          <div className='p-3 flex flex-col gap-2'>

          {/* 날짜 조회 */}
          <div className='grid lg:grid-cols-2 grid-cols-1 gap-2'>
            <div className=''>
              <p>시작 날짜</p>
              <input type='date' className='w-full mt-1 h-12 bg-[#2E2E2E] p-2 px-2 rounded-md outline-none border-[1px] border-gray-400' value={startDate} onChange={(e)=>setStartDate(e.target.value)}/>
            </div>    
            <div className=''>
              <p>종료 날짜</p>
              <input type='date' className='w-full mt-1 h-12 bg-[#2E2E2E] p-2 px-2 rounded-md outline-none border-[1px] border-gray-400' value={endDate} onChange={(e)=>setEndDate(e.target.value)} />
            </div>              
          </div>   

          {/* 언더라인 */}
          <div className='border-b-[1px] border-gray-400 py-1'></div>

          <form autoComplete='off'>
            {/* 판매 취소 */}
            <div className='flex flex-col gap-2 pt-2'>
              <button className='bg-[#2E2E2E] h-12 w-[100%] rounded-md text-center border-[1px] border-yellow-300' onClick={btnSearchClick} >
                판매량 조회
              </button>
            </div>
          </form>

          <div>
            <div className='bg-[#2E2E2E] p-3 rounded-md'>
              <p className='whitespace-normal'>지정된 시작 날짜와 종료 날짜 기준으로 시간대별 모든 판매, 서비스, 시연용으로 처리된 데이터들을 표시합니다.</p>
            </div>
          </div>

          {/* <div className='grid grid-cols-3 justify-center items-center text-center'>
            <div className='border-b-[1px] border-gray-400'></div>
            <p className='text-center'>또는</p>
            <div className='border-b-[1px] border-gray-400'></div>
          </div> */}

          </div>
        </div>

      </div>

    </div>

  )
}

export default Chart_2